






























import { computed, defineComponent, toRefs } from '@nuxtjs/composition-api'
import { useClassifiedForm } from '~/compositions/form'
import { formFieldProps } from '~/constants/form'
import { useDep } from '~/compositions/dependency-container'
import FormValidationBuilder from '~/builders/form/FormValidationBuilder'
import { useId } from '~/compositions/id'
import FieldError from '~/components/car/classifieds/form/fieldsets/fields/FieldError.vue'

export default defineComponent({
  props: formFieldProps,
  components: { FieldError },
  setup(props) {
    const { name, specs } = toRefs(props)
    const {
      value,
      error,
      isValid,
      debouncedValueChanged,
      suggestions
    } = useClassifiedForm(props)

    const { createRandomId } = useId()
    const datalistId = createRandomId('freetext-form-handler')
    const formValidationBuilder = useDep(FormValidationBuilder)

    const minLength = computed(() => specs.value?.min || 0)
    const maxLength = computed(() => specs.value?.max || 1000000)

    const placeholder = computed(() => specs.value?.placeholder)

    const prefix = computed(() => specs.value?.website)

    function handleTextInput(text: string) {
      formValidationBuilder
        .new(error)
        .minChars(minLength.value, text, true)
        .maxChars(maxLength.value, text)
        .validate()

      debouncedValueChanged(name.value, text)
    }

    return {
      value,
      error,
      isValid,
      handleTextInput,
      placeholder,
      minLength,
      datalistId,
      maxLength,
      suggestions,
      prefix
    }
  }
})
